import config from 'config';
import {
  refreshTokenRequest,
  refreshTokenDone,
  refreshTokenCancel,
  logoutRequest,
  logoutDone,
  loginJWTAuth,
} from 'actions/auth';
import { disconnectWs } from 'actions/websockets';
import history from 'modules/history';

import { rawPost } from './http';
import { localStorage } from './storage';

let store = null;
export const init = (s) => {
  store = s;
};

export const refreshToken = () => {
  if (!store) return Promise.reject('utils/auth not initialized');
  const user = store.getState().user;
  const renewingAuthToken = store.getState().renewingAuthToken;
  if (!user) return Promise.reject();
  if (Date.now() < user.expires) return Promise.resolve(user);

  if (renewingAuthToken) {
    // Wait until the auth token is renewed
    return new Promise((resolve) => {
      let unsubscribe = store.subscribe(() => {
        if (!store.getState().renewingAuthToken) {
          // istanbul ignore if: redux-mock-store does not return unsubscribe functions
          if (typeof unsubscribe === 'function') unsubscribe();
          resolve(store.getState().user);
        }
      });
    });
  } else {
    // Renew the AUTH token
    store.dispatch(refreshTokenRequest());

    const authConfig = config.getAuthConfig(localStorage.getItem('useSAML'));
    return rawPost(authConfig.REFRESH_TOKEN.url, {
      ...authConfig.REFRESH_TOKEN.params,
      [authConfig.REFRESH_TOKEN.token_key]: user.refresh_token,
    })
      .catch((err) => {
        store.dispatch(refreshTokenCancel(err));
        throw err;
      })
      .then((response) => ({
        ...user,
        ...response,
        ...{ expires: Date.now() + response?.expires_in * 1000 },
      }))
      .then((userInfo) => {
        if (localStorage.getItem('useSAML')) {
          userInfo = loginJWTAuth(userInfo.access_token);
        }
        return userInfo;
      })
      .then((userInfo) => {
        if (localStorage.getItem('useSAML')) {
          loginJWTAuth(userInfo.access_token);
        }
        localStorage.setItem('mercuryUser', JSON.stringify(userInfo));

        return userInfo;
      })
      .then((userInfo) => {
        store.dispatch(refreshTokenDone(userInfo));
        return userInfo;
      });
  }
};

export const authHeader = (user) =>
  !user ? {} : { Authorization: `${user.token_type} ${user.access_token}` };

export const jwtAuthHeader = (token = localStorage.getItem('sso_token')) =>
  token ? { Authorization: `Bearer ${token}` } : {};

export const hardLogout = () => {
  store.dispatch(logoutRequest());
  localStorage.removeItem('mercuryUser');
  localStorage.removeItem('sso_token');
  localStorage.removeItem('useSAML');
  store.dispatch(disconnectWs());
  store.dispatch(logoutDone());
  history.push(config.BASE_ROUTE + 'login');
};
